<mat-card>
  <app-cart-data-renderer
    [cart]="cart"
    [keys]="[
      'destination',
      'nDays',
      'start',
      'end',
      'plan',
      'fullName',
      'email',
      'locale'
    ]"
  ></app-cart-data-renderer>
</mat-card>
